/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f79b4cd0"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" 确认解绑吗？解绑后角色不再绑定GS："), /*#__PURE__*/_createElementVNode("span")], -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, " 注：解绑第二天0点生效 ", -1));
const _hoisted_3 = {
  class: "dialog-footer"
};
import { apiDelPlayer } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'unbindModal',
  emits: ['ok'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const infoData = ref();
    const dialogVisible = ref(false);
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const show = payload => {
      dialogVisible.value = true;
      if (payload.data) infoData.value = payload.data;
    };
    const emits = __emit;
    const handleOk = async () => {
      var _infoData$value;
      const res = await apiDelPlayer({
        id: (_infoData$value = infoData.value) === null || _infoData$value === void 0 ? void 0 : _infoData$value.id
      });
      if (res.code === 0) {
        handleClose();
        emits('ok');
      }
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_dialog = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "解绑",
        width: "600px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleOk
        }, {
          default: _withCtx(() => [_createTextVNode(" 确定 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_hoisted_1, _hoisted_2]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});